import { fromJS } from 'immutable'
import has from 'has'

const initialState = fromJS({
  title: '',
  message: '',
  level: 'success',
  position: 'bl',
  autoDismiss: 5,
  dismissible: true,
  action: null,
  actionState: false,
  show: false,
})

export default function notification(state = initialState, action) {
  // catch errors on preflight
  const pending = /.*_REQ$/

  // show notification on preflight error
  if (action.type.match(pending)) {
    if (action.error) {
      return state.merge(fromJS({
        message: action.payload.message,
        show: true,
        level: 'error',
      }))
    }
  }

  switch (action.type) {
    // show notification on success
    case 'PERMISSION_SAVE_SUCC':
    case 'ROLEPERM_SAVE_SUCC':
    case 'NOTIF_SUCC': {
      let msg = 'Action successful.'
      if (has(action, 'meta') && action.meta && has(action.meta, 'msg')) {
        msg = action.meta.msg
      }
      return state.merge(fromJS({
        message: msg,
        show: true,
        level: 'success',
      }))
    }
    // show notification on fail
    case 'NOTIF_FAIL': {
      let msg = action.payload.message
      if (has(action.payload, 'response') && has(action.payload.response, 'error')) {
        msg = action.payload.response.error
      }
      return state.merge(fromJS({
        message: msg,
        show: true,
        level: 'error',
      }))
    }

    // hide notification
    case 'NOTIF_HIDE':
      return state.set('show', false)

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/components/Notification/reducer.js